import { EntityRelation } from 'app/shared/models/entity-relation.model';
import { EditRelationshipComponent } from 'app/entities/relations/editrelationship/edit-relationship.component';
import { EntityIdDetails, EntityType } from './../../../shared/models/entity-id-details.model';
import { ExecutiveSummary } from './../../../shared/models/executive-summary.model';
import { MdDialog, MdDialogRef, MdDialogConfig } from '@angular/material';
import { Component, OnChanges, ViewContainerRef, Input } from '@angular/core';

import { EntityCafService } from 'app/entities/caf/entity-caf.service';

@Component({
    selector: 'summary-details',
    templateUrl: './summary-details.component.html'
})

export class SummaryDetailsComponent implements OnChanges {
    @Input() entityIdDetails: EntityIdDetails;
    executiveSummary: ExecutiveSummary;
    dialogRef: MdDialogRef<any>;

    constructor(private cafService: EntityCafService,
        private viewContainerRef: ViewContainerRef,
        private dialog: MdDialog) { }

    ngOnChanges() {
        if (this.entityIdDetails.entityId) {
            this.loadExecutiveSummary();
        }
    }

    loadExecutiveSummary() {
        this.cafService.getExecutiveSummary(
            this.entityIdDetails.entityId).subscribe(response => {
                this.executiveSummary = response;
            });
    }

    openEditRelationDialog(commentType: string, text) {
        const config = new MdDialogConfig();
        config.disableClose = true;
        config.viewContainerRef = this.viewContainerRef;
        const entityRelation = new EntityRelation();
        entityRelation.entityId = this.entityIdDetails.entityId;
        if (this.entityIdDetails.entityType === EntityType.CLIENT
            || this.entityIdDetails.entityType === EntityType.ORGANISATION) {
            entityRelation.detailId = this.entityIdDetails.orgId;
        } else {
            entityRelation.detailId = this.entityIdDetails.personId;
        }
        entityRelation.commentVO = this.executiveSummary;
        entityRelation.entityType = this.entityIdDetails.entityType;

        this.dialogRef = this.dialog.open(EditRelationshipComponent, config);
        this.dialogRef.componentInstance.comment = text;
        this.dialogRef.componentInstance.relation = entityRelation;
        this.dialogRef.componentInstance.commentType = commentType;
        this.dialogRef.componentInstance.entityId = this.entityIdDetails.entityId;
        this.dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.loadExecutiveSummary();
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/entities/caf/summarydetails/summary-details.component.ts